import { AGENDA_COURTS, AGENDA_EVENTS, AGENDA_TIMES, AgendaEventStatus } from 'modules/arena/dashboard/content';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';

const STATUS_CLASSES: Record<AgendaEventStatus, string> = {
  paid: 'border-success/30 bg-success-soft text-success',
  pending: 'border-warning/30 bg-warning-soft text-warning',
  blocked: 'border-border bg-chip text-ink-secondary',
  class: 'border-accent bg-accent-soft text-primary-dark',
  free: 'border-dashed border-border/60 text-ink-secondary/40',
};

export function AgendaGrid() {
  const { profile } = useArenaProfile();
  // Colunas = quadras da arena cadastrada. Os eventos de exemplo do dia vão para a quadra
  // na mesma posição (1ª, 2ª…); quadras a mais aparecem livres, e eventos sem quadra somem.
  const courts = profile.courts.map((court) => court.name);
  const eventsByCell = new Map(
    AGENDA_EVENTS.flatMap((event) => {
      const court = courts[AGENDA_COURTS.indexOf(event.court)];
      return court ? [[`${court}|${event.time}`, event] as const] : [];
    })
  );

  return (
    <div className="overflow-x-auto">
      <div
        className="grid gap-2"
        style={{ gridTemplateColumns: `80px repeat(${courts.length}, minmax(140px, 1fr))`, minWidth: 80 + courts.length * 148 }}
      >
        <div />
        {courts.map((court) => (
          <div key={court} className="truncate text-center text-sm font-semibold text-ink" title={court}>
            {court}
          </div>
        ))}

        {AGENDA_TIMES.map((time) => (
          <div key={time} className="contents">
            <div className="flex items-start pt-2 text-xs text-ink-secondary">{time}</div>
            {courts.map((court) => {
              const event = eventsByCell.get(`${court}|${time}`);

              return (
                <div
                  key={`${court}-${time}`}
                  className={`min-h-[64px] rounded-lg border px-2 py-1.5 text-xs ${
                    event ? STATUS_CLASSES[event.status] : STATUS_CLASSES.free
                  }`}
                >
                  {event ? (
                    <>
                      <p className="font-medium leading-tight">{event.label}</p>
                      <p className="mt-0.5 opacity-80">{event.meta}</p>
                    </>
                  ) : (
                    'livre'
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
